import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

const STATUS_COLOR_CLASSES: Record<StatusPagamentoEnum, string> = {
  [StatusPagamentoEnum.paid]: "text-[#1bbb48]",
  [StatusPagamentoEnum.pending]: "text-[#e0bf1d]",
  [StatusPagamentoEnum.canceled]: "text-[#ff0000]",
  [StatusPagamentoEnum.refunded]: "text-[#ee6f27]",
  [StatusPagamentoEnum.expired]: "text-[#9d9d9d]",
};

export function getStatusColorClass(status: StatusPagamentoEnum) {
  return STATUS_COLOR_CLASSES[status] ?? "text-[#2d2d2d]";
}
